module.exports = __webpack_public_path__ + "static/media/bar-pin.bba54996.svg";